// TODO @consumer: Move to global components

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CURRENCY, getCurrencySymbol } from '../../../constants/currency';
import { formatPriceForDisplay } from '../../../util/format-money';
import Placeholder from './Placeholder';

const propTypes = {
  price: PropTypes.number,
  oldPrice: PropTypes.number,
  showDiscount: PropTypes.bool,
  trimDecimalZeros: PropTypes.bool,
  currency: PropTypes.oneOf(Object.values(CURRENCY)),
  animatedStrikethrough: PropTypes.bool,
  className: PropTypes.string,
  loading: PropTypes.bool,
  suffix: PropTypes.node,
  title: PropTypes.string,
};

const PriceDisplay = ({
  price,
  oldPrice,
  showDiscount,
  trimDecimalZeros = true,
  currency = CURRENCY.USD,
  animatedStrikethrough,
  className,
  loading,
  suffix,
  title,
}) => {
  const classes = classNames({
    'price-display': true,
    'animated-strikethrough': animatedStrikethrough,
    'is-loading': loading,
    [className]: !!className,
  });

  if (loading) {
    return <Placeholder className={classes} />;
  }

  const renderPrice = value => {
    const symbol = getCurrencySymbol(currency);
    const formatted = formatPriceForDisplay(value, trimDecimalZeros);
    const [integer, decimal] = formatted.split('.');

    return (
      <Fragment>
        {symbol}
        {integer}
        {decimal && <sup>{decimal}</sup>}
      </Fragment>
    );
  };

  const shouldDisplayDiscount = oldPrice > price && showDiscount;

  return (
    <span className={classes} title={title}>
      {shouldDisplayDiscount && (
        <>
          <del className="price-display-discount">
            {renderPrice(oldPrice)}
          </del>{' '}
        </>
      )}
      <span className="price-display-value">{renderPrice(price)}</span>

      {suffix && <span className="price-display-suffix">{suffix}</span>}
    </span>
  );
};

PriceDisplay.propTypes = propTypes;

export default PriceDisplay;
